export const APP_STORE_LINKS = {
  ios: 'https://apps.apple.com/ca/app/nova-adult-hockey/id6755668669',
  android: 'https://play.google.com/store/apps/details?id=com.halifaxpickuphockeyhfx.app'
}

